var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-torch.858a5b8a.png","uri@2x": __webpack_public_path__ + "icon-torch.42de61be.png","uri@3x": __webpack_public_path__ + "icon-torch.a2d21731.png",
    width: 50,
    height: 50
});